<template>
  <div :class="'mb-2 ' + classes.row">
    <b for="address" :class="classes.label">{{ label }}</b>
    <div :class="classes.input">
      <textarea :placeholder="label" autocomplete="off" class="form-control" v-bind="$attrs" :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)" :rows="rows" />
      <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">{{
        error.$message
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType, defineProps } from "vue";
const props = defineProps({
  modelValue: {
    type: [String, Number, null] as PropType<string | number | null>,
    default: null,
  },
  label: { type: String },
  rows: { type: Number , default: 2},
  type: { type: String },
  typeStyle: { type: String, default: "" },
  v: {
    type: Object,
  },
});
const classes = computed(() => {
  switch (props.typeStyle) {
    case "product":
      return {
        name: "product",
        row: "row",
        label: "col-sm-3 col-form-label",
        input: "col-sm-9",
      };
      break;
    default:
      return { name: "profile", row: "", label: "form-label", input: "" };
      break;
  }
});
</script>

<style scoped></style>
